import type {
    OutlookSpace,
    OutlookSpaceAsset,
    ProjectId,
    TimeStreamProjects,
} from 'owa-timestream-types';
import insertProject from './insertProject';
import updateProject from './updateProject';
import updateProjectAssets from './updateProjectAssets';

export default function upsertProject(
    projects: TimeStreamProjects,
    projectId: ProjectId,
    outlookSpace: OutlookSpace,
    outlookSpaceAssets?: OutlookSpaceAsset[],
    newlyCreated?: boolean,
    isPreview?: boolean
) {
    const possibleProject = projects.get(projectId);

    const project = possibleProject
        ? updateProject(possibleProject, outlookSpace)
        : insertProject(projects, projectId, outlookSpace, newlyCreated, isPreview);

    updateProjectAssets(project, outlookSpaceAssets);

    return project;
}
